export type TabOptions = 'roundtrip' | 'onewaytrip' | 'customtrip';

export const tabOptionValue = {
  roundtrip: 'Ida e Volta',
  onewaytrip: 'Somente Ida',
  customtrip: 'Roteiro Personalizado'
};

export type MinhaContaOptions =
  | 'dados'
  | 'minhas-reservas'
  | 'orcamentos'
  | 'seguranca';

export type RoteiroPersonalizadoSteps = 'data' | 'dias' | 'info';

export type Destino = {
  horarioSaida: string;
  lugarSaida: AddressPoint;
  lugarDestino: AddressPoint;
  pontosEmbarque?: (AddressPoint | undefined)[];
};

export type Dia = {
  data: string;
  destinos: Destino[];
  vaiUsarVeiculoNoDia?: boolean;
};

export interface Log {
  id: number;
  message: string;
  extra_data: any;
  user?: string;
}

export interface Customer {
  id: number;
  name: string;
  email: string;
  document: string;
  tel: string;
}

export type PaymentType = 'paynow' | 'paylater';
export interface DriverExpensesAlt {
  payDriverExpenses: PaymentType;
  driverExpensesValue: number;
}

export interface DriverExpenses {
  paymentType: PaymentType;
  driverExpensesValue: number;
}

export interface DriverExpensesCheckout {
  enable: boolean;
  payDriverExpenses: PaymentType;
}

export interface AddressPoint {
  address: string;
  address_components: {
    route?: string;
    state: string;
    state_short: string;
    city: string;
    district: string;
    postal_code?: string;
  };
  city: string;
  lat: number;
  lng: number;
  date?: string;
  time?: string;
}

interface DateAndTime {
  date: string;
  time: string;
}

export interface TravelDetails {
  type: TabOptions;
  origem: AddressPoint;
  dataIda: string;
  destino: AddressPoint;
  dataVolta: string;
  embarques: AddressPoint[];
}

export interface TripDates {
  start: DateAndTime;
  startEnd: DateAndTime;
  startForUser: DateAndTime;
  userLastTime: DateAndTime;
  endInitial: DateAndTime;
  end: DateAndTime;
  endForUser: DateAndTime;
}

export interface SelectedVehicle {
  id: number;
  name: string;
  priceCents: string;
  priceCentsOld: string;
  factor_usage: number;
  thumbnail: string;
  configurations: any[];
  gallery: any[];
  bathroom: boolean;
  air_conditioning: boolean;
  type: string;
  image: string;
  title: string;
}

export interface TripDetails {
  driverExpenses: DriverExpensesAlt;
  origin: AddressPoint;
  destination: AddressPoint;
  observations?: string;
  stopPoints: AddressPoint[];
}

export interface Vehicle {
  id: number;
  ref: string;
  title: string;
  gallery: { src: string }[];
  image: string;
  thumbnail?: string;
  class: string;
  type: string;
  capacity: number;
  totalCapacity: number;
  axios: string | null;
  bathroom: boolean;
  air_conditioning: boolean;
  name?: string;
  has_antt: boolean;
  priceKM: number;
  dailyPrice: number;
  overnightPrice: number;
  totalAvailable: number;
  configurations: any[];
  visible: boolean;
  factor_usage: number;
  priceCents: number;
  discount: boolean;
  discountMultiplier: number;
  difference: number;
  priceCentsOld: string;
  pricePerSeat: string;
  priceLabel: string;
  priceLabelOld: string;
  observations: string;
  seasonalityCoeficient: number;
  seasonalityPriceCents: number;
  usingTwoTrips: boolean;
  metas: {
    priceData: PriceData;
    realDiffDays: number;
    pricePerSeat: string;
    priceCents: number;
    priceCentsOld: number;
    seasonalityCoeficient: number;
    minPriceDeparture: number;
  };
}

interface PriceData {
  mileageData: MileageData;
  dailyData: DailyData;
  timeData: TimeData;
  overnight: Overnight;
  value: number;
  valueWithoutExtras: number;
  normalPrice?: number;
  minPriceData?: {
    minPriceDeparture: number;
    usingTwoTrips: boolean;
  };
}

export interface Trip {
  driverExpenses: DriverExpensesAlt;
  origin: AddressPoint;
  observations?: string;
  destination: AddressPoint;
  stopPoints?: (AddressPoint | undefined)[];
}

export interface Route {
  date: string;
  destination: AddressPoint;
  origin: AddressPoint;
  stop_points: AddressPoint[];
  time: string;
}

export interface ItineraryDay {
  active: boolean;
  date: string;
  routes: Route[];
}
export interface Item {
  total: string;
  type: string;
  id: number;
  quote_id: number;
  vehicle: Vehicle;
  trip: Trip;
  metas: ItemMetas;
  itinerary?: {
    customer_id: number;
    days: ItineraryDay[];
    disabledDates: {
      to: string;
    };
    hideDestination: boolean;
    initialDate: string;
    endDate: string;
    status: boolean;
    step: number;
    tripDays: number;
  };
}

export interface ItemMetas {
  driverExpenses: number;
  garage: number;
  tripDates: TripDates;
  tripScope: string;
  mapsData: OriginalPointsDistance;
  garagePoint: Coordinates;
  garageDetails: Garage;
  oneWayDistance: number;
  originalPointsDistance: OriginalPointsDistance;
  distanceBetweenGarageAndOrigin: number;
  hoursBetweenGarageAndOrigin: number;
  totalDistance: number;
  totalDuration: number;
  securityMargin: number;
  totalDistanceAndSecurity: number;
  additionalMileage: number;
  minTripDate?: MinTripDate;
  dayUse: DayUse;
  driverExpensesData: DriverExpensesData;
  seasonalities: Seasonalities;
  priceData: PriceData;
  realDiffDays: number;
  pricePerSeat: string | number;
  priceCents: number;
  priceCentsOld: number;
  seasonalityCoeficient: number;
  minPriceDeparture: number;
}

export interface MileageData {
  distance: number;
  value: number;
  kmValue: number;
}

export interface DailyData {
  dailyPrice: number;
  value: number;
  days: number;
  coefMileageDaily: number;
}

export interface TimeData {
  time: number;
  value: number;
  hourValue: number;
  timePriceWithoutExtra: number;
  extraTimePrice: number;
  extraHours: number;
}

export interface Overnight {
  perNight: number;
  count: number;
  value: number;
}
export interface Seasonality {
  id: number;
  cumulative_id?: string;
  name: string;
  start_date?: string;
  end_date?: string;
  factor: number;
  observation: string;
  created_at: string;
  updated_at: string;
  address?: string;
  city?: string;
  uf?: string;
  district?: string;
  postal_code?: string;
  cumulative?: boolean;
  full_address: string;
  real_factor: number;
}
export interface Seasonalities {
  allChosen: {
    forPeriod?: Seasonality;
    forAddress?: Seasonality;
  };
  value: number;
}
export interface DriverExpensesData {
  value: number;
  days: number;
  numberDrivers: number;
  minDistanceDouble: number;
  driverExpensesBase: number;
  distanceConsidered: number;
}

export interface DayUse {
  dayUse: number;
  totalHours: number;
  difference: number;
  daysWithoutDiff: number;
  isSameDay: boolean;
}

interface MinTripDate {
  start: string;
  end: string;
  minTripDate: string;
  distanceTimeHours: number;
}
export interface OriginalPointsDistance {
  distanceTime: number;
  distanceKM: number;
  points: {
    origin: Coordinates;
    destination: Coordinates;
    stopPoints: Coordinates[];
  };
  pairDistances: PairsDistances;
}

export interface Garage {
  id: number;
  name?: string;
  zipcode: string;
  address: string;
  lat: number;
  lng: number;
  city: string;
  state: string;
  origin_agency_id: number;
}
export interface Coordinates {
  lat: number;
  lng: number;
  id?: number;
}

interface PairsDistances {
  pair: {
    time: number;
    distance: number;
  };
}

export interface Quote {
  uuid: string;
  has_availability: number;
  created_at: string;
  id: number;
  addition: number;
  total: number;
  discount: number;
  subtotal: number;
  datePaid?: string | null;
  status: string;
  statusSlug: string;
  statusId: number;
  paymentMethod: string;
  installments?: string | null;
  coupon?: string | null;
  customer: Customer;
  logs: Log[];
  items: Item[];
  metas: any[];
  user: any;
}

export interface MapsData {
  distanceTime: number;
  distanceKM: number;
  points: Coordinates;
  pairsDistances: PairsDistances;
}

export interface BuscaMetas {
  driverExpenses: number;
  garage: number;
  tripDates: TripDates;
  mapsData: MapsData;
  garagePoint: Coordinates;
  garageDetails: Garage;
  oneWayDistance: number;
  originalPointsDistance: OriginalPointsDistance;
  distanceBetweenGarageAndOrigin: number;
  hoursBetweenGarageAndOrigin: number;
  totalDistance: number;
  totalDuration: number;
  securityMargin: number;
  totalDistanceAndSecurity: number;
  additionalMileage: number;
  minTripDate: MinTripDate;
  dayUse: DayUse;
  driverExpensesData: DriverExpensesData;
  seasonalities: Seasonalities;
  tripScope: string;
}

export interface DistanceData {
  distance: OriginalPointsDistance;
  originPoint: Coordinates;
  destinationPoint: Coordinates;
  stopPoints: Coordinates[];
  tripsStartDistance: number;
}

export interface BuscaSplitMeta {
  isTripSplit: boolean;
  tripSplitType: string;
  mapsData: MapsData;
  distanceData: DistanceData;
  garagePoint: Coordinates;
  garageDetails: Garage;
  oneWayDistance: number;
  customToFinalGarage: number;
  originalPointsDistance: OriginalPointsDistance;
  distanceBetweenGarageAndOrigin: number;
  hoursBetweenGarageAndOrigin: number;
  totalDistance: number;
  totalDuration: number;
  securityMargin: number;
  totalDistanceAndSecurity: number;
  additionalMileage: number;
  tripDates: TripDates;
}
